let _accessToken: string | null = null;

/** Returns the current in-memory Auth0 access token, or null if not set. */
export function getAuth0AccessToken(): string | null {
  return _accessToken;
}

/** Stores the Auth0 access token in memory. */
export function setAuth0AccessToken(token: string): void {
  _accessToken = token;
}

/** Clears the in-memory Auth0 access token. */
export function clearAuth0AccessToken(): void {
  _accessToken = null;
}
